import {
  Container,
  Heading,
  Stack,
  Button,
  VStack,
  Text,
} from "@chakra-ui/react";
import { JETBRAINS_PLUGIN_URL } from "../constants/urls";

interface CallToActionProps {
  showHeader?: boolean;
}

export default function CallToAction({ showHeader = true }: CallToActionProps) {


  return (
    <Container maxW={"7xl"} px={{ base: 4, md: 8 }}>
      <Stack
        textAlign={"center"}
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 4, md: 15 }}
        style={{ paddingTop: "0 !important" }}
        mt="!important"
      >
        <VStack spacing={4} alignItems="center" width="100%">
          {showHeader && (
            <Heading
              fontWeight={600}
              fontSize={{ base: "3xl", sm: "4xl", md: "5xl", lg: "6xl" }}
              lineHeight={"110%"}
              mt="5rem"
              mb="0rem"
              textAlign={"center"}
              width="100%"
            >
              The Best AI Assistant for <br/>JetBrains IDEs
            </Heading>
          )}
          <Text fontSize={{ base: "lg", md: "xl" }} mb="2rem">
            Use your favorite JetBrains IDE without compromising on AI or <a href="https://docs.sweep.dev/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#805ad5", textDecoration: "underline" }}>privacy</a>.<br/>Install our Jetbrains plugin
          </Text>
          <Button
                colorScheme="purple"
                p={6}
                bg="purple.700"
                _hover={{ bg: "purple.500" }}
                color={"white"}
                onClick={() => window.open(JETBRAINS_PLUGIN_URL)}
                fontSize={{ base: "xl", md: "2xl" }}
                width={{base: "100%", sm: "300px"}}
            >
              Install Sweep
            </Button>
        </VStack>
      </Stack>
    </Container>
  );
}
